import React from 'react';
import Services from '../components/Services';
import Contact from '../components/Contact';

function ServicesPage() {
  return (
    <div className="page-transition pt-20">
      {/* Page Header */}
      <section className="py-20 bg-gradient-to-br from-green-500 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">Our Services</h1>
          <p className="text-xl text-green-100 max-w-2xl mx-auto">
            Comprehensive technology solutions tailored to transform your business
          </p>
        </div>
      </section>
      
      <Services />
      <Contact />
    </div>
  );
}

export default ServicesPage;